import * as React from "react";

import AvatarComponent from "./AvatarComponent";
import UserMenu from "./UserMenu";
import { Box } from "@mui/material";

export default function UserAvatar() {
  const [openUserMenu, setOpenUserMenu] = React.useState(null);
  const open = Boolean(openUserMenu);

  const handleClick = (event) => {
    setOpenUserMenu(event.currentTarget);
  };

  return (
    <>
      <Box sx={{ ml: 2 }}>
        <AvatarComponent open={open} onClick={handleClick} />
      </Box>

      <UserMenu
        open={open}
        openUserMenu={openUserMenu}
        setOpenUserMenu={setOpenUserMenu}
      />
    </>
  );
}
